// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Loader_ldsSpinner__evYBM","blue":"Loader_blue__IHzu0","white":"Loader_white__R5YHd"};